import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import {GRAY_DARKER} from 'ui-library/Colors';
import ErrorMessage from 'ui-library/ErrorMessage';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import TextField from 'ui-library/inputs/TextField';

import {SplitTransform} from '../../RunSchemaSpecConstants';
import {CSVTextAreaInput, SplitFormErrors, updateTransformationProperties} from './TransformFormUtils';

function getColumnNamesFromInput(value: string): Array<string | null> {
  const values = value.split(',').map((val) => val.trim());
  return values.map((value) => (value === 'null' ? null : value));
}

interface SplitFormProps {
  transform: SplitTransform;
  onChange: (transform: SplitTransform) => void;
  formErrors: SplitFormErrors;
}

export default function SplitForm(props: SplitFormProps): JSX.Element {
  return (
    <>
      <Row className={css(styles.columnNamesContainer)}>
        <Col md={12}>
          <FieldLabel label="New column names" labelStyle={LabelStyle.LABEL} isRequired={true} />
          <CSVTextAreaInput
            value={props.transform.transformationProperties?.outputColumnNames?.map(
              (columnName: string | null) => (columnName != null ? columnName : 'null')
            )}
            placeholder="Sample ID, Concentration"
            onChange={(value) => {
              props.onChange(updateTransformationProperties(props.transform, 'outputColumnNames', value));
            }}
            parseCSVInputFn={getColumnNamesFromInput}
            hasError={props.formErrors.outputColumnNames}
          />
          {props.formErrors.outputColumnNames ? <ErrorMessage error="Column names are required" /> : null}
          <div className={css(styles.description)}>Enter a list of columns, separated by comma.</div>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <TextField
            label="Delimiter"
            onChange={(e) => {
              props.onChange(updateTransformationProperties(props.transform, 'delimiter', e.target.value));
            }}
            labelStyle={FieldLabel.STYLES.LABEL}
            isRequired={true}
            value={props.transform.transformationProperties?.delimiter}
            hasError={props.formErrors.delimiter}
          />
          {props.formErrors.delimiter ? <ErrorMessage error="Delimiter is required" /> : null}
        </Col>
        <Col md={4}>
          <TextField
            label="Column to split"
            onChange={(e) => {
              props.onChange(updateTransformationProperties(props.transform, 'column', e.target.value));
            }}
            labelStyle={FieldLabel.STYLES.LABEL}
            isRequired={true}
            value={props.transform.transformationProperties?.column}
            hasError={props.formErrors.column}
          />
          {props.formErrors.column ? <ErrorMessage error="Column name is required" /> : null}
        </Col>
      </Row>
    </>
  );
}

const styles = StyleSheet.create({
  description: {
    fontSize: 13,
    lineHeight: '16px',
    color: GRAY_DARKER,
    paddingTop: '7px',
  },
  columnNamesContainer: {
    paddingBottom: '25px',
  },
});
